var module = angular.module('octopusApp.tenants');

module.directive('missingTagList', function($compile, octopusTagSets) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            tagList: '=',
            tagsAll: "="
        },
        link: function ($scope, $element, attrs) {
            $scope.$watchCollection('tagList', function() {
                if (!$scope.tagList || !$scope.tagsAll) {
                    return;
                }

                var groupedTags = octopusTagSets.groupByTagSet($scope.tagList);
                
                var allTagDetails = _.flatten($scope.tagsAll.map(function(ts) { return ts.Tags; }));
                var str = "";
                for (var tagSetName in (groupedTags || {})) {
                    var tagSet = groupedTags[tagSetName];

                    if (tagSet.length === 0 ){
                        continue;
                    }

                    if (str !== "") {
                        str += " and ";
                    }

                    if (tagSet.length === 1) {
                        str += buildTag(allTagDetails, tagSet[0]);
                    } else {
                        str += '(';
                        for(var index = 0; index < tagSet.length; index++) {
                            var tag = tagSet[index];
                            if (index === tagSet.length -1){
                                str += " or ";
                            } else if (index !== 0) {
                                str += ", ";
                            }
                            var tagHtml = buildTag(allTagDetails, tag);
                            str += tagHtml;
                        }
                        str += ')';
                    }
                }

                $element.html(str);
                $compile($element.contents())($scope);
            });
        }
    };

    function buildTag(allTagDetails, tagName) {

        var thisTagDetails = allTagDetails.filter(function(a) { return a.CanonicalTagName === tagName ; })[0];
        if (!thisTagDetails) {
            return '';
        }

        return '<span class="label label-info" style="background-color:'+ thisTagDetails.Color +'">'+ thisTagDetails.Name +'</span>';
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/advanced_tenant_selector/missing_tag_list.js
// module id = 623
// module chunks = 1